import {DoraProperty} from '../../../Decorators/Decorator';

export class ChartOption {
    @DoraProperty
    path =  '';
    @DoraProperty
    type = '';
    @DoraProperty
    value = '';

    private valueArray: string[] = null;
  public static create(path: string, type: string, value: string): ChartOption {
    const result: ChartOption = new ChartOption();
    result.path = path;
    result.type = type;
    result.value = value;

    return result;
  }

  public static createArray(path: string, value: string[]): ChartOption {
    const result: ChartOption = new ChartOption();
    result.path = path;
    result.type = 'a';
    result.valueArray = value;

    return result;
  }

  // tslint:disable-next-line:ban-types
    private buildRoot(dst: Object, root: string) {
      if (root === null) {
        return dst;
      }

      const path: string[] = this.path.split('\\');

      // analyze first element
      const idxPart = this.extractRootIdx(path[0]);
      if (idxPart === '') {
        // Object
        if (dst[root] === undefined) {
          dst[root] = {};
        }
        return dst[root];
      }

      // array
      if (dst[root] === undefined) {
        dst[root] = [];
      }

      const idx = Number(idxPart.substr(1, idxPart.length - 2));
      if (dst[root][idx] === undefined) {
        dst[root][idx] = {};
      }

      return dst[root][idx];
    }

  /**
   * extract string containing root idx.
   * Eg. '[10]myParams'  return '[10]'
   * @param path first path
   * @return '' if no idx found
   */
    private extractRootIdx(path: string): string {
      if (path.startsWith('[') === false) {
        return '';
      }
      const end = path.indexOf(']');
      return path.substr(0, end + 1);
    }
    // tslint:disable-next-line:ban-types
    public setOption(dst: Object, root: string): void {
        const rootObj = this.buildRoot(dst, root);
        const path: string[] = this.path.split('\\');
        this.setValue(rootObj, path, 0);
    }

    // tslint:disable-next-line:ban-types
    private setValue(dst: Object, path: string[], idx: number): void {
        if (path.length === idx + 1) {
            // set value
            let value: any;
            switch (this.type.toLowerCase()) {
                case 'number':
                case 'n':
                    value = Number(this.value);
                    break;
                case 'boolean':
                case 'b':
                    value = this.value.toLowerCase() === 'true' ? true : false;
                    break;
                case 'array':
                case 'a':
                    value = this.valueArray;
                    break;
                default:
                    value = this.value;
            }
            const rootIdxPart = this.extractRootIdx(path[idx]);
            const myPath = path[idx].substring(rootIdxPart.length);
            if (rootIdxPart !== '') {
              const paramIdx = Number(rootIdxPart.substr(1, rootIdxPart.length - 2));

              if (myPath === '') {
                // it is an array element
                // check if dst is an array
                if (dst === undefined || dst instanceof Array === false) {
                  dst = [];
                }

                // set value into array
                dst[paramIdx] = value;
              } else {
                if (dst[myPath] === undefined) {
                  dst[myPath] = [];
                }
                dst[myPath][paramIdx] = value;
              }
            } else {
              dst[myPath] = value;
            }
        } else {
            const newDst = this.getElement(dst , path[idx], this.isPathArray(path[idx+1]));
            this.setValue(newDst, path, idx + 1);

            // dst[path[idx]] = {};
            // this.setValue(dst[path[idx]], path, idx + 1);
        }
    }

    private isPathArray(path: string): boolean {
      if (path.endsWith(']') && path.startsWith('[')) {
        // count number of '['
        let count = 0;
        // tslint:disable-next-line:prefer-for-of
        for (let idx = 0; idx < path.length; idx++) {
          if (path[idx] === '[') {
            count++;
          }
        }
        return count === 1 ? true : false;
      }
      return false;
    }
  // tslint:disable-next-line:ban-types
  private getElement(dst: Object, path: string, nextisarray: boolean): Object {
      // remove root idx if any
      const rootIdxPart = this.extractRootIdx(path);
      const myPath = path.substring(rootIdxPart.length);

      if (myPath.endsWith(']') === false) {
        // it isn't an array
        if (dst[myPath] === undefined) {
          if (nextisarray) {
            dst[myPath] = [];
          } else {
            dst[myPath] = {};
          }
        }
        return dst[myPath];
      }
      // is an array
      const parts: string[] = myPath.split('[');
      if (parts.length !== 2) {
        console.log('Invalid parameter: ' + myPath);
        return null;
      }

      const arrayIdx = Number(parts[1].substr(0, parts[1].length - 1));
      if (dst[parts[0]] === undefined) {
        dst[parts[0]] = [];
      }

      if (dst[parts[0]][arrayIdx] === undefined) {
        if (nextisarray) {
          dst[parts[0]][arrayIdx] = [];
        } else {
          dst[parts[0]][arrayIdx] = {};
        }
      }

      return dst[parts[0]][arrayIdx];
  }
}
